export enum Language {
  HR = 'hr',
  EN = 'en',
}

export enum PaymentLanguage {
  HRV = 'HRV',
  ENG = 'ENG',
}
